import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Eye } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VisitorCounter = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const already = sessionStorage.getItem("pakla_visited");
        let n;
        if (already) {
          const r = await axios.get(`${API}/visitors/count`);
          n = r.data?.count ?? 0;
        } else {
          const r = await axios.post(`${API}/visitors/track`);
          n = r.data?.count ?? 0;
          sessionStorage.setItem("pakla_visited", "1");
        }
        if (!cancelled) setCount(n);
      } catch (e) {
        if (!cancelled) setCount(null);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, []);

  if (count === null) return null;

  const formatted = count.toLocaleString("tr-TR");

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40"
      data-testid="visitor-counter"
    >
      <div className="flex items-center gap-3 bg-[#0F3D2E] text-[#FAF7F0] rounded-full pl-3 pr-5 py-2.5 shadow-2xl border border-[#2E8B4A]/40 backdrop-blur">
        <span className="inline-flex w-8 h-8 rounded-full bg-[#2E8B4A]/25 items-center justify-center">
          <Eye size={16} strokeWidth={1.8} />
        </span>
        <div className="flex flex-col leading-none">
          <span className="font-ubuntu font-bold text-[15px] tabular-nums" data-testid="visitor-count-value">{formatted}</span>
          <span className="text-[9px] tracking-[0.22em] uppercase text-[#FAF7F0]/70 mt-0.5">Ziyaretçi</span>
        </div>
      </div>
    </motion.div>
  );
};

export default VisitorCounter;
